import { render, staticRenderFns } from "./Internados.vue?vue&type=template&id=5aa6139c&"
import script from "./Internados.vue?vue&type=script&lang=js&"
export * from "./Internados.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports